import { Http } from '@/utils/request';
import { TypeParams } from './type/appType';
import { S3TokenType } from './type/s3TokenType';
import { AppCountryMethod, MainResponseType, CountryItem } from './type/shippingType';
import { TeamAppTypeListReplyItem } from './type/teamType';

//获取APP Type信息
export const getAppType = async () => {
  return await Http.get(`open-app-bff/apps/all/types`).json<APIRes<TypeParams[]>>();
};

//获取团队Type信息
export const getTeamAppType = async () => {
  return await Http.get(`open-app-bff/teams/all/types`).json<APIRes<TeamAppTypeListReplyItem[]>>();
};

//获取s3临时token
export const getS3Token = async () => {
  return await Http.get(`dsers-infra-bff/s3sts`).json<APIRes<S3TokenType>>();
};

// 获取国家列表
export const getCountrysList = async (params: { teamId: string; appId: string }) => {
  return await Http.get(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/countrys`
  ).json<APIRes<CountryItem[]>>();
};

// 获取shipping method列表
export const getShippingMethodsList = async (params: { teamId: string; appId: string }) => {
  return await Http.get(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/shipping_methods`
  ).json<APIRes<CountryItem[]>>();
};

// 创建shipping
export const addShippingList = async (data: MainResponseType) => {
  return await Http.post(
    `open-app-bff/users/me/teams/${data.teamId}/apps/${data.appId}/shippings`,
    {
      json: data,
    }
  ).json<APIRes<MainResponseType>>();
};

// 获取shipping列表
export const getShippingList = async (params: { teamId: string; appId: string }) => {
  return await Http.get(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/shippings`
  ).json<APIRes<MainResponseType>>();
};
